class Company {
  constructor(root) {
    this.root = root;

    this.historySwiperEl = this.root.querySelector(".js-history-swiper");

    this.init();
    this.mount();
  }
  init() {
    this.historySwiperEl && this.historySwiper();
  }
  mount() {}
  historySwiper() {
    const prevEl = this.root.querySelector(".js-history-swiper__prev");
    const nextEl = this.root.querySelector(".js-history-swiper__next");
    new Swiper(this.historySwiperEl, {
      loop: false,
      slidesPerView: "auto",
      slidesPerGroup: 3,
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
    });
  }
}
